import {
  useGetApiV1GroupsQuery,
  useGetApiV1GroupsNameByGroupnameQuery,
} from '../../api/groups'
import { useCurrentUser } from '@wellesley/user'
import useUserChange from 'hooks/useUserChange'
import { useMemo } from 'react'

export const useUserGroups = (currentGroupName?: string) => {
  const { user } = useCurrentUser()
  const userId = user?.id

  const {
    data: userGroups,
    isLoading: isGroupsLoading,
    isFetching: isGroupsFetching,
    isUninitialized: isGroupsUninitialized,
    refetch: refetchGroups,
  } = useGetApiV1GroupsQuery({}, { skip: !userId })

  const isGuestGroup = useMemo(() => {
    return !userGroups?.some((group) => group.groupName === currentGroupName)
  }, [userGroups, currentGroupName])

  const {
    data: currentGroup,
    isLoading: isCurrentGroupLoading,
    isFetching: isCurrentGroupFetching,
  } = useGetApiV1GroupsNameByGroupnameQuery(
    { groupname: currentGroupName || '' },
    {
      skip:
        !currentGroupName || isGroupsLoading || (userGroups && !isGuestGroup),
    },
  )

  useUserChange({
    onChange: () => {
      if (!isGroupsUninitialized) {
        void refetchGroups()
      }
    },
  })

  return {
    isLoading:
      isGroupsLoading ||
      isGroupsFetching ||
      isCurrentGroupLoading ||
      isCurrentGroupFetching,
    userGroups: userGroups || [],
    guestGroup: isGuestGroup && currentGroupName ? currentGroup : undefined,
    refetchUserGroups: refetchGroups,
    isUninitialized: isGroupsUninitialized,
  }
}
